var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.styling,attrs:{"href":"#","tabindex":_vm.tabIndex,"role":"button","aria-disabled":_vm.ariaDisabled},on:{"click":_vm.setMotion}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }